import React, { useCallback } from "react";

import Container from "react-bootstrap/Container";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { Footer, FooterItem } from "../../components/Footer/Footer";
import { aboutProgramRoute, statementOfAcessibilityRoute } from "../../routes/routes";
import { Navbar } from "../Navbar/Navbar";
import styles from "./Layout.module.scss";
import Navigation from "./Navigation";

interface Props {
  children?: React.ReactNode;
}

export default function Layout({ children }: Props) {
  const { t } = useTranslation();
  const history = useHistory();

  const downloadUserManual = () => {
    window.open("/docs/NISOO - korisnicke upute.docx");    
  };

  const downloadPrivacyNotice = () => {
    window.open("/docs/Obavijest o privatnosti_NISOO_vp.docx");
  };

  // NISOO2 const downloadTermsOfService = () => {};

  const setImpairedStyle = useCallback(() => {
    document.documentElement.classList.add("theme-vision-impaired");
    document.documentElement.classList.remove("theme-default");
  }, []);

  const removeImpairedStyle = useCallback(() => {
    document.documentElement.classList.add("theme-default");
    document.documentElement.classList.remove("theme-vision-impaired");
  }, []);

  // NISOO2 const showHelpAndSupport = () => history.push("/help-and-support");
  const showAboutProgram = () => history.push(aboutProgramRoute());
  const showStatementOfAccessibility = () => {
    window.scrollTo(0, 0);
    history.push(statementOfAcessibilityRoute);
  }
  // NISOO2 const showFaq = () => history.push("/faq");

  const footerItems: Array<FooterItem> = [
    //{
    //  label: t("footer.faq"),
    //  callback: (item: FooterItem) => {
    //    showFaq();
    //    return false;
    //  },
    //},
    {
      label: t("footer.help"),
      callback: (item: FooterItem) => {
        downloadUserManual();
        return false;
      },
    },
    //{
    //  label: t("footer.eula"),
    //  callback: (item: FooterItem) => {
    //    showHelpAndSupport();
    //    return false;
    //  },
    //},
    {
      label: t("footer.about"),
      callback: (item: FooterItem) => {
        showAboutProgram();
        return false;
      },
    },
    {
      label: t("footer.statementOfAccessibility"),
      callback: (item: FooterItem) => {
        showStatementOfAccessibility();
        return false;
      },
    },
    {
      label: t("footer.privacyNotice"),
      callback: (item: FooterItem) => {
        downloadPrivacyNotice();
        return false;
      },
    },
  ];

  return (
    <div className={styles.layout}>
      <Navbar
        setImpairedStyle={setImpairedStyle}
        removeImpairedStyle={removeImpairedStyle}
      />
      <Navigation />
      <main className={styles.main + ' ' + styles.mainWhite}>
        <Container className={styles.container}>{children}</Container>
      </main>
      <Footer items={footerItems} />
    </div>
  );
}
